<!--评价表-->
<template>
  <a-modal
    title="招标项目信息"
    :maskClosable="false"
    :width="1200"
    :confirmLoading="confirmLoading"
    :visible="true"
    @ok="handleSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
    :dialog-style="{ top: '20px' }">

    <a-spin tip="加载中......" :spinning="!ebidAgencyLoadFinish || !expertLoadFinish">
      <Tabs @change="tabChangeCallback">

        <TabPane :key="0" :tab="'招标代理：' + agencyInfo.tenderAgencyName == 'undefined'?'':agencyInfo.tenderAgencyName">
          <score-board ref="scoreForm"
                       :bidProjectId="assessmentParam.bidProjectId"
                       :sectionId="assessmentParam.sectionId"
                       :evalClause="evalClause"
                       :input-disabled="inputDisable"></score-board>
        </TabPane>

        <TabPane  v-for="(tabItem, index) in committeeMemList" :key="index + 1" :tab="'专家：' + tabItem.expertName">
          <score-board-with-option ref="optionForm"
                                   :bidProjectId="assessmentParam.bidProjectId"
                                   :sectionId="assessmentParam.sectionId"
                                   :evalClauseWithOption="scoreBoardData[currentTabKey]"
                                   :input-disabled="inputDisable"></score-board-with-option>
        </TabPane>

        <TabPane v-if="showSecTab" :key="999" :tab="'项目响应方'">
          <SignFileShow v-if='assessmentParam.bidProjectId' :bidProjectId='assessmentParam.bidProjectId' :type='"SecondOpenTableStamp"'></SignFileShow>
        </TabPane>
     </Tabs>
    </a-spin>
    <template slot="footer">
      <a-button v-show="showBtn" type="primary" @click="handleAutoInput" style="margin-right: 50px">一键填写</a-button>

      <a-button @click="handleCancel">关闭</a-button>

      <a-button :loading="confirmLoading" v-show="showBtn" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>

</template>

<script>

import ScoreBoard from "@views/ebid/modules/ScoreBoard";
import ScoreBoardWithOption from "@views/ebid/modules/ScoreBoardWithOption";
import {TabPane} from "ant-design-vue/lib/tabs";
import {Tabs} from "ant-design-vue/es";
import {getAction, postAction} from "@api/manage";
import {clone} from "xe-utils/methods";
import SignFileShow from '@views/bobidopen/modules/SignFileShow.vue'

export default {
  name: "AssessmentModal",
  props: ["assessmentParam", "evalTargetList"],
  components: {
    SignFileShow,
    Tabs,
    TabPane,
    ScoreBoard,
    ScoreBoardWithOption,
  },
  watch: {},
  created() {
    let userInfo = this.$store.getters.userInfo;
    this.evalCreateType = userInfo.roleCode
    this.getEvalTargetInfo()
    this.getServiceEvalInfo();
    this.getSection();
  },
  data() {
    return {
      busiType: "",
      confirmLoading: false,
      currentTabKey: 0,
      lastTabKey: 0,
      evalCreateType: "",
      evalClause: [],
      evalClauseWithOption: [],
      committeeMemList: [],
      agencyInfo: {},
      scoreBoardData: [],
      tabData: {},
      // vue 组件排序
      vueComponentOrder: 1,
      vueComponentOrderDict: {0: 0},
      showBtn: false,
      inputDisable: false,
      ebidAgencyLoadFinish:false,
      expertLoadFinish:false,
      showSecTab:true
    }
  },
  methods: {
    close() {
      this.$emit('closeAssessment');
      this.visible = false;
    },
    handleCancel() {
      this.close()
    },
    getSection()
    {
      getAction("/ebid-ce/tmBidSection/queryById",{id:this.assessmentParam.sectionId}).then(res=>{
        if(res.success){
          if(res.result.tenderProjectClassifyCode.indexOf('A01A01A11')>-1||
            res.result.tenderProjectClassifyCode.indexOf('A01A01A07')>-1)
          {
            this.showSecTab=false;
          }
        }else {

        }
      });
    },
    getServiceEvalInfo() {
      let param = {"bidProjectId": this.assessmentParam.bidProjectId, "sectionId": this.assessmentParam.sectionId}
      getAction("/ebid-ce/tmBidProject/queryServiceEval", param).then(res => {
        if (res.success) {
          //此前未对此项目服务评价时
          if (res.result.length == 0){
            for (let item of this.evalTargetList) {
              // 获取每个评价对象的评价条款
              this.getServiceEvalConfig(item)
              this.inputDisable = false
            }
            return
          }
          this.expertLoadFinish = true
          this.ebidAgencyLoadFinish = true
          this.inputDisable = true;
          let tempDict = {}
          // 遍历结果，重新将结果组成“代理”、“专家”数组
          for (let item of res.result) {
            // 如果记录是代理的，则存入evalClause
            if ("0" == item.evalType) {
              this.evalClause.push(item)
            } else if ("1" == item.evalType) {
              // 记录是专家的，根据专家进行重组，先存起来
              if (!tempDict[item.evalTargetId]) {
                tempDict[item.evalTargetId] = []
              }
              tempDict[item.evalTargetId].push(item)
            }
          }

          this.scoreBoardData.push(this.evalClause)
          for (let item in tempDict) {
            // 根据专家重组好的结果，存入结果数组中
            this.scoreBoardData.push(tempDict[item])
          }
        } else {
          this.$message.error("查询数据失败，请刷新页面重试！")
        }
      });
    },
    getEvalTargetInfo() {
      for (let item of this.evalTargetList) {
        switch (item) {
          case "ebid_agency":
            this.getAgencyInfoByBid()
            break
          case "expert":
            this.getCommitteeMemBySectionId()
            break
          default:
            break
        }
      }
    },
    // 一键填写评价
    handleAutoInput() {
      if (this.currentTabKey == 0) {
        this.$refs.scoreForm.autoInputResult()
      } else {
        // 获取vue组件点击顺序
        let vueCompOrder = this.vueComponentOrderDict[this.currentTabKey];
        // 因为optionForm和scoreForm是两个独立form，scoreBoardData下标是上一个tab的下标，optionForm对应下标要用当前的tab下标减代理scoreForm个数
        this.$refs.optionForm[vueCompOrder-1].autoInputResult()
      }
    },
    handleSubmit() {
      // 保存最后一个tab的数据
      if (this.currentTabKey == 0) {
        if (this.$refs.scoreForm.$data.dataSource) {
          this.$set(this.scoreBoardData, 0, this.$refs.scoreForm.$data.dataSource);
        }
      } else {
        if (this.$refs.optionForm) {
          let vueCompOrder = this.vueComponentOrderDict[this.currentTabKey];
          // 因为optionForm和scoreForm是两个独立form，scoreBoardData下标是上一个tab的下标，optionForm对应下标要用当前的tab下标减代理scoreForm个数
          this.$set(this.scoreBoardData, this.currentTabKey, this.$refs.optionForm[vueCompOrder - 1].$data.dataSource);
        }
      }

      // 判断是否有评价还没写完
      if (!this.judgeCompleteInput()) {
        this.$message.warning("还有未填写完的评价，请填写后重试！")
        return;
      }

      // 提交评价
      this.confirmLoading = true
      postAction("/ebid-ce/tmBidProject/addServiceEval", this.scoreBoardData).then(res=> {
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('loadData');
        } else {
          this.$message.error(res.message)
        }
        this.close()
        this.confirmLoading = false
      })
    },
    // tab页切换
    tabChangeCallback(key) {
      if(key != 999) {
        // 记录上一次的tab，从哪个tab跳转到当前tab
        this.lastTabKey = this.currentTabKey
        // 获取当前活动的tab
        this.currentTabKey = parseInt(key)

        // 记录点击tab的顺序，先判断页面是否已经登记过，登记过则不动，反之则进行登记
        if (!this.vueComponentOrderDict.hasOwnProperty(this.currentTabKey)) {
          this.vueComponentOrderDict[this.currentTabKey] = this.vueComponentOrder
          this.vueComponentOrder += 1
        }

        // 缓存评分数据
        this.cacheEvalData()
      }
    },
    // 如果没有结果数据，则创建初始结果数据
    initData(){
      if (!this.scoreBoardData || this.scoreBoardData.length == 0) {
        for (let item of this.evalClause) {
          item.evalTargetId = this.agencyInfo.tenderAgencyId
          item.evalTargetName = this.agencyInfo.tenderAgencyName
          item.id = null
        }
        this.scoreBoardData.push(this.evalClause)
        let cloneEvalClause
        for (let i = 0; i < this.committeeMemList.length; i++) {
          cloneEvalClause = clone(this.evalClauseWithOption, true)
          // TODO 这边暂时用committeeMem中的id作为targetId，后续可能要换成脱敏的专家身份证号或者其他标识
          for (let item of cloneEvalClause) {
            item.evalTargetId = this.committeeMemList[i].id
            item.evalTargetName = this.committeeMemList[i].expertName
            item.id = null
          }
          this.scoreBoardData.push(cloneEvalClause)
        }
      }
    },
    // 缓存评分数据
    cacheEvalData() {
      this.initData()
      // 如果当前活动的0，则为评价代理的tab；否则是评价专家的
      if (this.lastTabKey == 0) {
        if (this.$refs.scoreForm.$data.dataSource) {
          this.$set(this.scoreBoardData, 0, this.$refs.scoreForm.$data.dataSource);
        }
      } else {
        if (this.$refs.optionForm) {
          // 获取vue组件点击顺序
          let vueCompOrder = this.vueComponentOrderDict[this.lastTabKey];
          // 因为optionForm和scoreForm是两个独立form，scoreBoardData下标是上一个tab的下标，optionForm对应下标要用当前的tab下标减代理scoreForm个数
          this.$set(this.scoreBoardData, this.lastTabKey, this.$refs.optionForm[vueCompOrder-1].$data.dataSource);
        }
      }
    },
    // 获取评分条款
    getServiceEvalConfig(evalTargetType) {
      if (!evalTargetType || evalTargetType == null) {
        return
      }
      let param = {"evalCreateType": this.evalCreateType, "evalTargetType": evalTargetType}
      getAction("/ebid-ce/tmBidProject/queryServiceEvalConfig", param).then(res => {
        if (res.success) {
          for (let item of res.result) {
            this.$set(item, "bidProjectId", this.assessmentParam.bidProjectId)
            this.$set(item, "sectionId", this.assessmentParam.sectionId)
          }
          switch (evalTargetType) {
            case "ebid_agency":
              this.evalClause = res.result
              this.ebidAgencyLoadFinish = true
              break
            case "expert":
              this.evalClauseWithOption = res.result
              this.expertLoadFinish = true
              break
            default:
              break
          }
          //确保招标代理和专家的条款数据都加载完再初始化数据
          if (this.ebidAgencyLoadFinish && this.expertLoadFinish){
            //将专家的初始化评价内容数据存入要提交数据的集合中，为的是要同时提交招标代理和专家的评价内容，否则判空无法提交成功
            this.initData()
          }
        }
      });
      this.showBtn = true;
    },
    // 获取某招标项目的招标代理信息
    getAgencyInfoByBid() {
      let param = {"bidProjectId": this.assessmentParam.bidProjectId}
      getAction("/ebid-ce/tmBidProject/queryAgencyInfoByBid", param).then(res => {
        if (res.success) {
          this.agencyInfo = res.result
        }
      });
    },
    // 获取某标段的专家信息
    getCommitteeMemBySectionId() {
      let param = {"bidProjectId": this.assessmentParam.bidProjectId, "sectionId": this.assessmentParam.sectionId}
      getAction("/ebid-ce/boCommitteeMem/queryCommitteeMemBySectionId", param).then(res => {
        if (res.success) {
          this.committeeMemList = res.result
        }
      });
    },
    // 判断是否完成全部评价
    judgeCompleteInput() {
      // 如果没有结果，直接报错
      if (!this.scoreBoardData || this.scoreBoardData.length == 0) {
        return false;
      }
      // 判断是否有未填完的内容
      console.log(this.scoreBoardData)
      for (let itemx of this.scoreBoardData) {
        for (let itemy of itemx) {
          if (this.isEmptyContent(itemy.evalResult)) {
            // 如果有内容为空，则返回false
            return false
          }
        }
      }
      return true;
    },
    isEmptyContent(content) {
      if (typeof content == 'undefined') {
        return true;
      }
      if (typeof content == 'number') {
        return content == 'undefined' ? true : false
      }
      if (typeof content == 'object' || typeof content == 'string') {
        return content.length == 0 ? true : false
      }
      return false
    },
  }
}
</script>

<style scoped>

</style>